import React from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import MuiSwitch from '@material-ui/core/Switch';
import PropTypes from 'prop-types';

const Switch = ({ classes, i, treeTrace, errors, data, extraIndexForKey, onChange, value, mode }) => {
  const { field, label, options, noOptionsMessage, direction, disabledOnEdit, validate, layout } = i;

  return (
    <div
      className={classes.inputContainer}
      style={Object.assign(
        {},
        layout === 'horizontal'
          ? {
              flexDirection: 'row',
              alignItems: 'center',
            }
          : {},
      )}
    >
      <p
        style={{ marginBottom: 5, fontWeight: 400 }}
        className={cn(
          classes.inputLabel,
          i.disabledOnEdit && mode === 'EDIT' && classes.disabledText,
          errors[i.field] && classes.textLabelError,
        )}
      >
        {i.label}: {errors[i.field]}
      </p>
      <div
        className={classes.input}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderBottomWidth: 0,
        }}
      >
        {i.leftLabel && <span className={classes.switchInputLabel}>{i.leftLabel}</span>}
        <MuiSwitch
          disabled={i.disabledOnEdit && mode === 'EDIT'}
          checked={value || false}
          color="primary"
          style={
            {
              // backgroundColor: '#315382',
              // color: '#315382',
            }
          }
          onChange={evt => onChange(i.field, !value, treeTrace)}
          className={cn(
            classes.switchInput,
            errors[i.field] && classes.textInputError,
            // i.disabledOnEdit && mode === 'EDIT' && classes.disabledInput,
          )}
          {...i}
        />
        {i.rightLabel && <span className={classes.switchInputLabel}>{i.rightLabel}</span>}
      </div>
    </div>
  );
};

Switch.propTypes = {
  treeTrace: PropTypes.arrayOf(PropTypes.object),
  errors: PropTypes.object,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  i: PropTypes.shape({
    field: PropTypes.string.isRequired,
    label: PropTypes.string,
    validate: PropTypes.array,
  }),
};

Switch.defaultProps = {
  treeTrace: [],
  errors: {},
  data: {},
  extraIndexForKey: 0,
  onChange: () => {},
  numberOfChildren: 0,
};
export default withStyles(styles)(Switch);
